// export default {
//   methods: {
//     isProtectionEnabled() {
//       return process.env.VUE_APP_DISABLE_RIGHT_CLICK === "true";
//     },

//     handleRightClick(e) {
//       if (this.isProtectionEnabled()) {
//         e.preventDefault();
//         return false;
//       }
//     },

//     disableDownloadKeys(e) {
//       if (!this.isProtectionEnabled()) return;

//       if (
//         (e.ctrlKey && e.key === "s") ||
//         (e.ctrlKey && e.key === "u") ||
//         (e.ctrlKey && e.shiftKey && e.key === "I") ||
//         e.key === "F12" ||
//         (e.ctrlKey && e.shiftKey && e.key === "C") ||
//         (e.ctrlKey && e.shiftKey && e.key === "J")
//       ) {
//         e.preventDefault();
//       }
//     },
//   },

//   mounted() {
//     if (this.isProtectionEnabled()) {
//       window.addEventListener("keydown", this.disableDownloadKeys);
//     }
//   },

//   beforeUnmount() {
//     window.removeEventListener("keydown", this.disableDownloadKeys);
//   },
// };


import { onMounted, onBeforeUnmount } from "vue";

export default function rightClickProtection() {
  const isProtectionEnabled = () => {
    return process.env.VUE_APP_DISABLE_RIGHT_CLICK === "true";
  };

  const handleRightClick = (e) => {
    if (!isProtectionEnabled()) return;

    e.preventDefault();
    return false;
  };

  const disableDownloadKeys = (e) => {
    if (!isProtectionEnabled()) return;

    if (
      (e.ctrlKey && e.key.toLowerCase() === "s") ||
      (e.ctrlKey && e.key.toLowerCase() === "u") ||
      (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") ||
      (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "c") ||
      (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") ||
      e.key === "F12"
    ) {
      e.preventDefault();
    }
  };

  onMounted(() => {
    if (!isProtectionEnabled()) return;

    document.addEventListener("contextmenu", handleRightClick);
    window.addEventListener("keydown", disableDownloadKeys);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("contextmenu", handleRightClick);
    window.removeEventListener("keydown", disableDownloadKeys);
  });
}